import eventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'

const $modalConfirm = $('#modal_confirm_reset')
const $buttonReset  = $('button.reset')

$('button.confirm_reset').click(eventBus.emitter('player wants to reset save'))
$('button.close_reset').click(hideModal)

$('#modal_confirm_reset').click(hideModal)
$('#modal_confirm_reset .modal_content').click(function (e) {
    e.stopPropagation()
})

eventBus.on('menu hidden', hideButton)
eventBus.on('menu displayed', showButton)



const fadeDelay = 500
function hideButton () {
    $buttonReset.off('click', showModal)
    $buttonReset.fadeOut(fadeDelay)
}


function showButton () {
    $buttonReset.on('click', showModal)
    $buttonReset.fadeIn(fadeDelay)
}



function showModal () {
    hideButton()
    $modalConfirm.fadeIn(fadeDelay)
}



function hideModal () {
    showButton()
    $modalConfirm.fadeOut(fadeDelay)
}


